import { render } from "./CompleteGoogleRegistration.vue?vue&type=template&id=4761b746&scoped=true"
import script from "./CompleteGoogleRegistration.vue?vue&type=script&lang=js"
export * from "./CompleteGoogleRegistration.vue?vue&type=script&lang=js"

import "./CompleteGoogleRegistration.vue?vue&type=style&index=0&id=4761b746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4761b746"]])

export default __exports__